import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import React, { useEffect, useState } from 'react';

function ThemeSelector({ toggleTheme, comoItem, aoEscolher }) {
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

    useEffect(() => {
        const storedTheme = localStorage.getItem('theme');
        if (storedTheme) {
            setTheme(storedTheme);
        }
    }, []);

    const renderThemeIcon = theme === 'light' ? <Brightness7Icon /> : <Brightness4Icon />;

    const trocar = () => {
        if (typeof toggleTheme === 'function') {
            toggleTheme();
            setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
        }
    };

    // Dentro do menu ⋮: linha com ícone e texto.
    if (comoItem) {
        return (
            <MenuItem onClick={() => { trocar(); if (aoEscolher) aoEscolher(); }}>
                <ListItemIcon>{theme === 'light' ? <Brightness4Icon fontSize="small" /> : <Brightness7Icon fontSize="small" />}</ListItemIcon>
                <ListItemText>{theme === 'light' ? 'Modo escuro' : 'Modo claro'}</ListItemText>
            </MenuItem>
        );
    }

    return (
        <IconButton
            color="inherit"
            onClick={() => {
                if (typeof toggleTheme === 'function') {
                    toggleTheme();
                    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
                } else {
                    console.error('toggleTheme não é uma função');
                }
            }}
            aria-label="Toggle theme"
        >
            {renderThemeIcon}
        </IconButton>
    );
}

export default ThemeSelector;
